// Import app modules.
window.TzOffsetController = function() {
    // The native timezone offset gives us the number of minutes that we'd have to add to
    // the LOCAL time in order to get the UTC time. However, we're going to use this on
    // the server, where we're already in UTC time. As such, in order to make the date
    // maths easier, we want to store the INVERSE OFFSET such that we can calculate the
    // LOCAL time from the UTC time.
    this.$el.value = -new Date().getTimezoneOffset();
};


document.addEventListener("alpine:init", function setupAlpineBindings() {
    Alpine.directive("auto-submit-button", $61d5fa5814b989e2$var$AutoSubmitButtonDirective);
});
/**
* I automatically submit the contextual form using the host button.
* 
* Note: This needs to be used on a button element (as opposed to a form element) so that
* any directives on the form itself (ex, x-prevent-double-submit) have time to initialize
* first (Alpine initializes from the top-down). 
*/ function $61d5fa5814b989e2$var$AutoSubmitButtonDirective(element, metadata, framework) {
    element.form.requestSubmit(element);
}


document.addEventListener("alpine:init", function setupAlpineBindings() {
    Alpine.directive("keyed-focus", $a5b30efb3a8d8f70$var$KeyedFocusDirective);
});
/**
* I listen to the `F` key as a means to move focus to the host element. This is being done
* to allow convenient focus without the accessibility concerns that come with the global
* `autofocus` attribute.
*/ function $a5b30efb3a8d8f70$var$KeyedFocusDirective(element, metadata, framework) {
    var triggerKey = "f";
    init();
    // ---
    // LIFE-CYCLE METHODS.
    // ---
    /**
	* I setup the directive.
	*/ function init() {
        framework.cleanup(destroy);
        window.addEventListener("keydown", handleKeydown);
    }
    /**
	* I tear down the directive.
	*/ function destroy() {
        window.removeEventListener("keydown", handleKeydown);
    }
    // ---
    // PRIVATE METHODS.
    // ---
    /**
	* I handle the keydown event on the window.
	*/ function handleKeydown(event) {
        // If the event was triggered for any other key, ignore event.
        if (event.key !== triggerKey) return;
        // If the key is modified in any way, ignore event. The user is doing something
        // specific and we don't want to interfere.
        if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
        // If the host element is already focused, there's nothing to do.
        if (document.activeElement === element) return;
        // If the currently active element is an input variation, ignore event. The user
        // may be working in a sibling input and we don't want to steal focus.
        if (document.activeElement?.matches("button, input, select, textarea")) return;
        // We're about to move focus to the host element before the key life-cycle has
        // completed. If we don't prevent the default behavior, the browser will render a
        // character (f) into the host element.
        event.preventDefault();
        element.focus();
    }
}


document.addEventListener("alpine:init", function setupAlpineBindings() {
    Alpine.directive("prevent-double-submit", $53230d1a9759c1c5$var$PreventDoubleSubmitDirective);
});
/**
* I prevent accidental double-form submissions.
*/ function $53230d1a9759c1c5$var$PreventDoubleSubmitDirective(element, metadata, framework) {
    var isSubmitting = false;
    window.addEventListener("pageshow", handlePageshow);
    element.addEventListener("submit", handleSubmit);
    // ---
    // PRIVATE METHODS.
    // ---
    /**
	* I get the relevant submission buttons.
	*/ function getButtons() {
        return element.querySelectorAll("button[type='submit'], input[type='submit']");
    }
    /**
	* I handle the pageshow event which is triggered when the page is rendered due to
	* browser navigation. This puts the form back into a submittable state so that the
	* user can re-submit it.
	*/ function handlePageshow(event) {
        // If the page wasn't pulled from the bfcache (Back/Forward), then the controller
        // is already in a good state.
        if (!event.persisted) return;
        isSubmitting = false;
        for (var node of getButtons()){
            node.classList.remove("isDisabled");
            node.disabled = false;
        }
    }
    /**
	* I handle the submit event, disabling buttons to prevent double-submission.
	*/ function handleSubmit(event) {
        if (isSubmitting) {
            event.preventDefault();
            console.info("Double form-submission prevented (x-prevent-double-submit).");
            return;
        }
        isSubmitting = true;
        for (var node of getButtons()){
            // All buttons are safe to "visually disable" since the above logic will act
            // as the ultimate control flow. The button rendering is just a UX issue.
            node.classList.add("isDisabled");
            // Note: we can't disable buttons that have a "name" attribute otherwise the
            // button "value" may not get submitted back to the server.
            if (!node.hasAttribute("name")) node.disabled = true;
        }
    }
}



var $1d9e71e27571c9ab$exports = {};
var $1051a56647a5a5e6$exports = {};
window.pm14ud = {
    ErrorMessage: $1051a56647a5a5e6$var$ErrorMessage
};
function $1051a56647a5a5e6$var$ErrorMessage() {
    return {
        init: $init
    };
    // ---
    // PUBLIC METHODS.
    // ---
    /**
	* I initialize the component.
	*/ function $init() {
        this.$el.focus();
        this.$refs.scrollTarget.scrollIntoView({
            behavior: "smooth",
            block: "start"
        });
    }
}



$1d9e71e27571c9ab$exports = {
    "js": $1051a56647a5a5e6$exports,
    "less": {}
};


var $0c34964dfd1dbe21$exports = {};
var $a3075d2479a03af1$exports = {};
window.izm317 = {
    FlashMessage: $a3075d2479a03af1$var$FlashMessage
};
function $a3075d2479a03af1$var$FlashMessage() {
    return {
        init: init
    };
    // ---
    // PUBLIC METHODS.
    // ---
    /**
	* I initialize the component.
	*/ function init() {
        // In order to make sure that the target page remains easily sharable; and, that
        // sharing the given URL doesn't constantly show the flash message; we're going to
        // remove the flash query-string parameter.
        var url = new URL(window.location.href);
        url.searchParams.delete("flash");
        url.searchParams.delete("flashData");
        window.history.replaceState({}, "", url);
        // Focus the flash message as well.
        this.$el.focus();
    }
}



$0c34964dfd1dbe21$exports = {
    "js": $a3075d2479a03af1$exports,
    "less": {}
};


var $90533ec6a183c50c$exports = {};

$90533ec6a183c50c$exports = {
    "less": {}
};


var $c3ecc8b9f53dc38d$exports = {};

$c3ecc8b9f53dc38d$exports = {
    "less": {}
};


var $8688886e18bf3d5a$exports = {};
var $531c21de00e9e9b7$exports = {};
window.jy2g1b = {
    Toaster: $531c21de00e9e9b7$var$Toaster
};
function $531c21de00e9e9b7$var$Toaster() {
    var host = this.$el;
    return {
        // Public properties.
        items: [],
        previouslyActiveElement: null,
        // Life-cycle methods.
        init: init,
        addItem: // Public Methods.
        addItem,
        handleKeydown: handleKeydown,
        handleToast: handleToast,
        removeItem: removeItem,
        shiftFocus: shiftFocus,
        unshiftFocus: unshiftFocus
    };
    // ---
    // LIFE-CYCLE METHODS.
    // ---
    /**
	* I initialize the component.
	*/ function init() {
    // ...
    }
    // ---
    // PUBLIC METHODS.
    // ---
    /**
	* I add a new item to the toast queue.
	*/ function addItem(message, isError = false) {
        this.items.unshift({
            uid: Date.now(),
            message: message,
            isError: isError
        });
        this.shiftFocus();
    }
    /**
	* I handle the keydown event when the dismiss button is focused.
	*/ function handleKeydown(event, index) {
        if (event.key === "Escape") {
            event.preventDefault();
            this.removeItem(index);
        }
    }
    /**
	* I add a new toast item based on the given event.
	*/ function handleToast(event) {
        this.addItem(event.detail.message, event.detail.isError);
    }
    /**
	* I remove the item at the given index.
	*/ function removeItem(index) {
        this.items.splice(index, 1);
        if (this.items.length) this.shiftFocus();
        else this.unshiftFocus();
    }
    /**
	* I shift the focus to the next most recent toast item.
	*/ function shiftFocus() {
        if (!this.previouslyActiveElement) this.previouslyActiveElement = document.activeElement || null;
        // Note: in Chrome (at least), there seems to be an issue where calling focus on
        // repeatedly-shown items doesn't always allow the focus to be transferred. So,
        // I'm using the next tick to give the browser a chance to chill out.
        this.$nextTick(()=>{
            host.querySelector(".item .dismiss")?.focus();
        });
    }
    /**
	* I shift the focus back to the previously active element what was in focus before the
	* toaster stole focus.
	*/ function unshiftFocus() {
        if (this.previouslyActiveElement) {
            this.previouslyActiveElement.focus();
            this.previouslyActiveElement = null;
        }
    }
}



$8688886e18bf3d5a$exports = {
    "js": $531c21de00e9e9b7$exports,
    "less": {}
};


var $ac53bec91880f566$exports = {};



$ac53bec91880f566$exports = {
    "_shared": {
        "layout": {
            "default": {
                "less": {}
            }
        }
    },
    "login": {
        "request": {
            "request": {
                "less": {}
            }
        }
    },
    "logout": {
        "success": {
            "success": {
                "less": {}
            }
        }
    }
};


// ----------------------------------------------------------------------------------- //
// ----------------------------------------------------------------------------------- //
// Note: by starting Alpine after the DOM is ready, it should give any other deferred
// scripts time to load and register components before Alpine is bootstrapped.
document.addEventListener("DOMContentLoaded", (event)=>{
    Alpine.start();
});


//# sourceMappingURL=auth.f6154646.js.map
